import React, { Component } from 'react';

import Box from '../ui/Box';
import { SelectField, MenuItem, RaisedButton, CircularProgress } from 'material-ui';

//providers
import DataService from '../../services/DataService';
var ds = DataService;

import MessageService from '../../services/MessageService';
var _mqtt = MessageService;



export default class PairLock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            all_dongles: [],
            selected_dongle: "",
            step: 1,
            process_id: -1
        }
    }
    componentDidMount() {
        this.getAllDongles();
        this.connectMqtt();
    }

    getAllDongles() {
        ds.getDevicesInRoom(this.props.room_id, data => {
            this.setState({
                all_dongles: data.filter(x => x.device_type_identifier == "SMART_DONGLE")
            })
        }, err => { });
    }

    connectMqtt() {
        _mqtt.disconnect()
        ds.getSwitchesInRoom(this.props.room_id, data => {
            if (data.mqttPassword) {
                _mqtt.connect(this.props.room_id, data.mqttPassword);
            }

        }, err => { });
    }

    subscribeToMQTT() {
        window.addEventListener('_mqt', (e) => {
            if (e && e.detail && e.detail.ev == "CFG_RCVD") {
                for (let i of this.state.all_dongles) {
                    if (i._id == this.state.selected_dongle && i.kd_id == e.detail.device_id) {
                        if (this.state.process_id != - 1) {
                            this.setState({ step: 3 }, () => {
                                this.savePairing();
                            })
                        }
                    }
                }
            }
        })
    }

    parLockStepOne(e) {
        e.preventDefault();
        ds.postPairLock({
            lock_device_id: this.props.lock_id,
            dongle_device_id: this.state.selected_dongle,
            intent: 1
        }, data => {
            this.setState({ step: 2, process_id: this.generateProcessId() },
                () => {
                    this.startNewTimer(this.state.process_id);
                });
        }, err => {
        })
    }

    savePairing() {
        ds.postPairLock({
            lock_device_id: this.props.lock_id,
            dongle_device_id: this.state.selected_dongle,
            intent: 2
        }, data => {
            this.setState({ step: 4, process_id: -1 });
        }, err => {
        })
    }


    startNewTimer(process_id) {
        setTimeout(() => {
            if (this.state.process_id == process_id) {
                this.setState({ step: -1, process_id: -1 })
            }
        }, 40 * 1000); //40 seconds
    }

    generateProcessId() {
        return new Date().getTime();
    }

    handleChangesSelect(e, i, selected_dongle) {
        this.setState({
            selected_dongle
        })
    }

    render() {
        return (<Box header='Pair Lock with a Dongle'>
            {this.state.step == 1 ? <form onSubmit={this.parLockStepOne.bind(this)}>
                <div className="row">
                    <div className="col-sm-6">
                        <SelectField
                            floatingLabelText="Select a Dongle To Pair"
                            value={this.state.selected_dongle}
                            name="field_type"
                            className="w-100"
                            onChange={this.handleChangesSelect.bind(this)}>
                            {
                                this.state.all_dongles.length ?
                                    this.state.all_dongles.map(obj => {
                                        return <MenuItem key={obj._id} value={obj._id} primaryText={obj.device_name} />
                                    })
                                    : <MenuItem key="NODONGLESS" disabled value={null} primaryText="No Dongles Registered" />
                            }
                        </SelectField>
                    </div>
                </div>
                <RaisedButton
                    disabled={!this.state.selected_dongle}
                    label="Pair"
                    primary
                    type="submit"
                />
            </form> : null}

            {this.state.step == 2 ? <div className="row text-center mtb-5rem">
                <div className="col-sm-12"> <CircularProgress mode="indeterminate" /></div>
                <div className="col-sm-12 mt-1vw">Waiting for Confirmation</div>
            </div> : null}
            {this.state.step == 3 ? <div className="row text-center mtb-5rem">
                <div className="col-sm-12"> <CircularProgress mode="indeterminate" /></div>
                <div className="col-sm-12 mt-1vw">Saving ...</div>
            </div> : null}
            {this.state.step == 4 ? <div className="row text-center mtb-5rem">
                <div className="col-sm-12"> <i className="material-icons indicating-icon">done</i></div>
                <h6 className="col-sm-12">Success! Lock and Dongle are paired</h6>
            </div> : null}
            {this.state.step == -1 ? <div className="row text-center mtb-5rem">
                <div className="col-sm-12"> <i className="material-icons indicating-icon">warning</i></div>
                <h3 className="col-sm-12">Pairing Failed</h3>
                <div className="col-sm-12">Check whether the dongle is connected to internet</div>
                <div className="col-sm-12 mt-2vw">
                    <RaisedButton
                        label="Try Again"
                        primary
                        type="button"
                        onClick={() => {
                            this.setState({ step: 1, process_id: -1 })
                        }}
                    />
                </div>
            </div> : null}
            {this.state.step == -2 ? <div className="row text-center mtb-5rem">
                <div className="col-sm-12"> <i className="material-icons indicating-icon">warning</i></div>
                <h3 className="col-sm-12">Pairing Failed</h3>
                <div className="col-sm-12">Some error occurred</div>
                <div className="col-sm-12 mt-2vw">
                    <RaisedButton
                        label="Try Again"
                        primary
                        type="button"
                        onClick={() => {
                            this.setState({ step: 1, process_id: -1 })
                        }}
                    />
                </div>
            </div> : null}
        </Box>)
    }

}


// WEBPACK FOOTER //
// ./components/rooms/PairLock.js